const DomainData = {
    domainItem: [
        {
            id:1,
            price:"3.99",
            domain:".dev"
        },
        {
            id:2,
            price:"9.9",
            domain:".info"
        },
        {
            id:3,
            price:"11.5",
            domain:".net"
        },
        {
            id:4,
            price:"10.99",
            domain:".store"
        },
        {
            id:5,
            price:"6.99",
            domain:".mobi"
        },
        {
            id:6,
            price:"18.99",
            domain:".biz"
        }
    ],

}


export default DomainData
